/**
 * `/profile/complete?return=…` — the old focused profile page, kept as an
 * address. The page is gone: its form is Your basics, a window over the page
 * it would have returned to (`?return=`, a same-origin path — Home otherwise).
 */
import { Redirect } from 'wouter';

import { legacyProfileCompleteTarget } from '../lib/profile-basics-href';

export function LegacyProfileCompleteRedirect() {
  const search = typeof window === 'undefined' ? '' : window.location.search;
  return <Redirect to={legacyProfileCompleteTarget(search)} replace />;
}
